const styles = () => ({
  root: {
    background: '#fdfdfe',
    borderRadius: 10,
    padding: '15px 30px 30px 30px',
    margin: '0 0 25px 0',
    border: '1px solid #F0F2F7',
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

export default styles;
